module.exports = __webpack_public_path__ + "img/woodkiteshield.f72cea17.png";